import { Theme } from "@emotion/react";
import { Button, ButtonProps as MuiButtonProps, SxProps } from '@mui/material';
import React, { MouseEventHandler, ReactNode } from "react";

interface ButtonProps {
    id: string;
    sx?: SxProps<Theme>;
    children?: ReactNode;
    variant?: MuiButtonProps['variant'];
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset'; 
    onClick?: MouseEventHandler<HTMLButtonElement>; 
}

const ButtonComponent = (props: ButtonProps) => {
    return <Button
        id={props.id}
        sx={props.sx}
        variant={props.variant}
        disabled={props.disabled}
        type={props.type}
        onClick={props.onClick}
    >
        {props.children}
    </Button>
}

export default ButtonComponent;